import React, { useMemo } from 'react';
import { isAuthGuarded as guarded } from '../../converters/path-converter';
import usePath from '../../redux/hooks/usePath';
import GuardedScreens from './guarded-screens/GuardedScreens';
import NoGuardedScreens from './no-guarded-screens/NoGuardedScreens';

const Root: React.FC = React.memo(() => {
  const { path } = usePath();
  const isAuthGuard = useMemo<boolean>(() => guarded(path), [path]);

  return (
    <>
      {!isAuthGuard && <NoGuardedScreens path={path} />}

      {isAuthGuard && <GuardedScreens />}
    </>
  );
});

export default Root;
